import inject from '@rover/utilities/injector';
import BrainTreeInstance from 'braintree-web/client';
import reportError from '@rover/utilities/reportError';

let braintreeInstance;

const BRAINTREE_TOKENIZATION_KEY = inject('Rover.context.BRAINTREE_TOKENIZATION_KEY');

const braintreeInstancePromise = BrainTreeInstance.create({
  authorization: BRAINTREE_TOKENIZATION_KEY,
});

export const getInstance = async () => {
  if (!braintreeInstance) braintreeInstance = await braintreeInstancePromise;
  return braintreeInstance;
};

export const encrypt = () => {
  reportError('The new Braintree SDK does not support encrypt.');
};



// WEBPACK FOOTER //
// ../utilities/braintree.js